import { NgModule } from '@angular/core';
import { ComponentsModule } from 'components/components.module';
import { PagesModule } from 'pages/pages.module';
import { TrainingOverviewPage } from 'pages/training-overview/training-overview';

@NgModule({
  declarations: [TrainingOverviewPage],
  imports: [PagesModule, ComponentsModule],
  exports: [TrainingOverviewPage]
})
export class TrainingOverviewPageModule { }
